import React, { useState } from 'react';
import { ArrowDown } from '@ankr.com/ui';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from 'tss-react/mui';

import { useTranslation } from 'modules/i18n';

import translation from './Executions/executions.translation';

interface Props {
  className?: string;
  executedAt: React.ReactNode;
  txHash: React.ReactNode;
  status: React.ReactNode;
  statusDot: React.ReactNode;
  cost: React.ReactNode;
}

export function ExpandedExecutionLog({
  className,
  executedAt,
  txHash,
  status,
  statusDot,
  cost,
}: Props): JSX.Element {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));

  const { classes, cx } = useStyles();
  const { t, keys } = useTranslation(translation);

  const [expanded, setExpanded] = useState(false);

  return (
    <div className={cx(classes.container, className)}>
      <div className={classes.panel} onClick={() => setExpanded(!expanded)}>
        <div className={classes.left}>
          {executedAt}

          {isMd && statusDot}
        </div>

        <ArrowDown
          className={cx(classes.arrow, expanded && classes.expanded)}
        />
      </div>

      {expanded && (
        <div className={classes.content}>
          <div className={classes.row}>
            <Typography
              variant="subtitle3"
              color={theme => theme.palette.grey[600]}
            >
              {t(keys.txHashCell)}
            </Typography>

            {txHash}
          </div>

          <div className={classes.row}>
            <Typography
              variant="subtitle3"
              color={theme => theme.palette.grey[600]}
            >
              {t(keys.statusCell)}
            </Typography>

            {status}
          </div>

          <div className={classes.row}>
            <Typography
              variant="subtitle3"
              color={theme => theme.palette.grey[600]}
            >
              {t(keys.costCell)}
            </Typography>

            {cost}
          </div>
        </div>
      )}
    </div>
  );
}

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    padding: theme.spacing(4, 0),
  },
  panel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  arrow: {
    color: theme.palette.grey[600],
  },
  expanded: {
    transform: 'rotate(180deg)',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
  },
}));
